import { Injectable } from '@angular/core';
import { FieldAgentClient, Dashboard, DashboardRequestParameters, SmartView } from 'ep-bt-field-agent-proxy';
import { EpbtFieldAgentService } from '../services/epbt-field-agent.service';

@Injectable({
  providedIn: 'root'
})
export class EpbtFaSmartTilesService {
  // currentUser: any;
  public dashboards: Dashboard[] = [];
  public smartViews: SmartView[] = [];
  public navigateTo: string = 'DefaultPage';
  public smartTileData: any;
  //public iFrameView: string;
  public isShow: boolean = true;
  public smartTilesTitle: string;

  public gridHeight : number;
  public gridInitialHeight : number;

  constructor(private client: FieldAgentClient, private fieldAgentService: EpbtFieldAgentService) {

  }

  public parse(sqlCommandText: string): string {
    this.fieldAgentService.getWebTrackUser((webTrackUser: any) => {

      if (sqlCommandText && webTrackUser) {
        var currentDate = new Date();
        var month = currentDate.getMonth() + 1;
        var year = currentDate.getFullYear();

        //check if any drilldown parameters and return empty string...
        if (sqlCommandText.indexOf("%drilldown") != -1) {
          return sqlCommandText = '';
        } else {
          // Replace tokens for userid, webtrackuserid, webtrackcustomerid and branchid.
          sqlCommandText = sqlCommandText.replace("%userid%", webTrackUser.bisTrackUserId.toString())
            .replace("%webtrackuserid%", webTrackUser.userId.toString())
            .replace("%webtrackcustomerid%", webTrackUser.customer.customerId.toString())
            .replace("%branchid%", webTrackUser.webTrackTradingBranch.branchID.toString())
            .replace("%currentyear%", year.toString())
            .replace("%currentmonth%", month.toString())
            .replace("%fiscalyear%", year.toString())
            .replace("%fiscalmonth%", month.toString());

          if (webTrackUser.customer.webTrackTradingBranchId != -1) {
            // Replace branch name and code tokens.
            sqlCommandText = sqlCommandText.replace("%branchname%", webTrackUser.webTrackTradingBranch.name)
              .replace("%branchcode%", webTrackUser.webTrackTradingBranch.code);
          }
        }
      }
    });

    return sqlCommandText;
  }

  parseSmartViewSmartTileSQL(sqlCommandText: string): string {
    this.fieldAgentService.getWebTrackUser((webTrackUser: any) => {
      if (sqlCommandText && webTrackUser) {
        var currentDate = new Date();
        var month = currentDate.getMonth() + 1;
        var year = currentDate.getFullYear();
        // Replace tokens for userid, webtrackuserid, webtrackcustomerid and branchid.
        sqlCommandText = sqlCommandText.replace("%userid%", webTrackUser.bisTrackUserId.toString())
          .replace("%webtrackuserid%", webTrackUser.userId.toString())
          .replace("%webtrackcustomerid%", webTrackUser.customer.customerId.toString())
          .replace("%branchid%", webTrackUser.webTrackTradingBranch.branchID.toString())
          .replace("%currentyear%", year.toString())
          .replace("%currentmonth%", month.toString())
          .replace("%fiscalyear%", year.toString())
          .replace("%fiscalmonth%", month.toString());

        if (webTrackUser.customer.webTrackTradingBranchId != -1) {
          // Replace branch name and code tokens.
          sqlCommandText = sqlCommandText.replace("%branchname%", webTrackUser.webTrackTradingBranch.name)
            .replace("%branchcode%", webTrackUser.webTrackTradingBranch.code);
        }
      }
    });
    return sqlCommandText;
  }


  setSmartTilesHeader(dashboardId: number) {
    this.fieldAgentService.getWebTrackUser((webTrackUser: any) => {
      this.client.getDashboardsForUser(webTrackUser).subscribe(res => {
        if (res != null) {
          var tilesLabel = res.find(d => d.dashboardID == dashboardId);
          this.smartTilesTitle = tilesLabel.name;
        }
      });
    });
  }

  setSmartViewHeader(dashboardId: number) {
    this.fieldAgentService.getWebTrackUser((webTrackUser: any) => {
      this.client.getSmartViewsForUser(webTrackUser).subscribe(res => {
        if (res != null) {
          var headerTitle = res.find(d => d.smartViewID == dashboardId);
          this.smartTilesTitle = headerTitle.name;
        }
      });
    });
  }
}
